export const appName = "garykirstencricketindia";
